import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "@/assets/locales/ru.json";

export const resources = {
  en: { translation: ru },
  ru: { translation: ru },
} as const;

export const defaultNS = "translation";

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "ru",
  defaultNS,
  ns: ["translation"],
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
